import { tabletBreakpoint } from 'react-components'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`

/*
 * Scoped rather than global on purpose -- two players can be mounted at once (the gallery grid
 * behind the image overlay), and createGlobalStyle is ref-counted, so closing the overlay used to
 * strip these rules from the still-mounted grid player.
 */
export const PlayerContainer = styled.div`
    [data-media-player] {
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
        overflow: visible;
        background-color: #000;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            border-radius: 0.5rem;
        }
    }

    [data-media-player] video {
        width: 100%;
        height: auto;
        display: block;
    }

    [data-media-provider] {
        display: block;
        width: 100%;
        height: 100%;
    }

    /*
     * Vidstack hit-tests gestures against this element's own box, so it has to cover the player --
     * unstyled it collapses to zero height and every click reads as out of bounds. It's forced to
     * pointer-events:none, so it never swallows clicks meant for the controls above it.
     */
    [data-media-gesture] {
        position: absolute;
        inset: 0;
        z-index: 0;
    }
`

export const VideoLoaderContainer = styled.div`
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    background-color: #000;
    aspect-ratio: 16 / 9;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const VideoLoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #000;
    z-index: 10;
    border-radius: 0.5rem;
`

export const Spinner = styled.div`
    border: 3px solid rgba(255, 255, 255, 0.2);
    border-top: 3px solid #fff;
    border-radius: 50%;
    width: 3.125rem;
    height: 3.125rem;
    animation: ${spin} 1s linear infinite;
`
